"use client";

import React from "react";
import { cx } from "class-variance-authority";
import CountUp from "react-countup";

export const dynamic = "force-dynamic";

const QuickFacts = () => {
    const counterData = [
        {
            id: 1,
            title: 100,
            bgColor: "bg-gradient-to-r from-[#FFDFC2] to-[#FDFDFD]",
            description: "Game Artists and Developers",
            suffix: "+",
        },
        {
            id: 2,
            title: 7,
            bgColor: "bg-gradient-to-r from-[#FFDFF4] to-[#FDFDFD]",
            description: "Years Of Experience",
            suffix: "+",
        },
        {
            id: 3,
            title: 3,
            bgColor: "bg-gradient-to-r from-[#C9E8FF] to-[#FDFDFD]",
            description: "Years Average Partnership",
            suffix: "+",
        },
        {
            id: 4,
            title: 90,
            bgColor: "bg-gradient-to-r from-[#E4D5FF] to-[#FDFDFD]",
            description: "Repeat Business",
            suffix: "%",
        },
    ];

    const counterList = counterData?.map((item) => {
        return (
            <div
                className={`w-full max-w-xs py-4 mx-auto rounded-[10px]  ${
                    item?.bgColor && item?.bgColor
                }`}
                key={item?.id}
            >
                <h2
                    id="counter"
                    className={`font-bold font-manrope text-5xl text-black`}
                >
                    <CountUp
                        start={0}
                        end={item?.title}
                        duration={2.75}
                        // prefix={item?.prefix}
                        suffix={item?.suffix}
                        enableScrollSpy
                    />
                </h2>
                <h3 className="text-[#424242]  px-8 mt-5 text-base font-semibold leading-5 font-manrope">
                    {item?.description}
                </h3>
            </div>
        );
    });

    return (
        <>
            <div className="container px-4 mx-auto mt-10 text-center md:px-24 lg:px-24 xl:px-0 ">
                <div className="grid gap-7 py-6 lg:grid-cols-4 md:grid-cols-2 place-content-center ">
                    {counterList}
                </div>
            </div>
        </>
    );
};

export default QuickFacts;
